module.exports = __webpack_public_path__ + "img/26.f38f8167.jpg";